// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-thread-layout {
  box-sizing: border-box;
}

.chat-thread-layout-inner:only-child,
.chat-thread-layout.py-0 .chat-thread-layout-inner {
  padding-top: 0;
  padding-bottom: 0.5rem;
  gap: 0.5rem;
}

.chat-composer-dock {
  background: #ffffff;
}

.chat-composer-shell:focus-within {
  border-color: rgba(10, 139, 199, 0.45);
  outline: 2px solid rgba(10, 139, 199, 0.25);
  outline-offset: 0;
}

.chat-composer-shell.border-0:focus-within {
  border-color: transparent;
  outline: none;
}

.chat-composer-unified:focus-within {
  border-color: rgba(10, 139, 199, 0.45);
  outline: 2px solid rgba(10, 139, 199, 0.25);
  outline-offset: 0;
}

.chat-stream-shimmer {
  height: 0.5rem;
  width: 8rem;
  border-radius: 9999px;
  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 40%, #e5e7eb 80%);
  background-size: 200% 100%;
  animation: chat-shimmer 1.4s ease-in-out infinite;
}

@keyframes chat-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.response-container {
  margin-bottom: 2rem;
}

.chat-assistant-row {
  font-size: 0.875rem;
  line-height: 1.5;
}

.chat-assistant-avatar,
.chat-assistant-avatar-spacer {
  flex: 0 0 auto;
  width: 1.3125rem;
  height: 1.3125rem;
}

.chat-assistant-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.chat-assistant-avatar img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.chat-assistant-body .chat-markdown-root {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #111827;
}

.response-container .chat-assistant-body .chat-markdown-root > :first-child,
.response-container .chat-assistant-body .chat-markdown-root > :first-child > :first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.chat-assistant-body .chat-markdown-root pre,
.chat-assistant-body .chat-markdown-root code {
  border-color: #e4e4e7;
}

.chat-assistant-body .chat-markdown-root pre {
  border-width: 1px;
  border-style: solid;
  border-radius: 0.5rem;
}

.chat-markdown-streamdown {
  --background: #ffffff;
  --foreground: #0f172a;
  --muted: #f4f4f5;
  --muted-foreground: #64748b;
  --border: #e8e8ea;
  --primary: #0a8bc7;
  --primary-foreground: #ffffff;
  --radius: 0.625rem;
}

.chat-markdown-streamdown .chat-markdown-table-scroll,
.chat-markdown-table-scroll {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 transparent;
}

.chat-markdown-streamdown table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.chat-markdown-mermaid,
.chat-markdown-streamdown [data-streamdown='mermaid'] {
  margin: 0.75rem 0;
  padding: 0.75rem;
  border: 1px solid #e4e4e7;
  border-radius: 0.625rem;
  background: #ffffff;
  overflow-x: auto;
}

/* Beat the icon-sized \`.prose svg\` rule in content-container.css */
.response-span .prose .chat-markdown-mermaid svg,
.message-span .prose .chat-markdown-mermaid svg,
.chat-markdown-mermaid svg {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  max-height: none !important;
  min-height: 220px;
  margin: 0 auto;
  vertical-align: baseline;
}

.chat-markdown-mermaid .chat-mermaid-canvas {
  width: 100%;
  overflow-x: auto;
}

.chat-assistant-body .chat-markdown-root .typing-cursor {
  transform: translateY(-0.05em);
}

.chat-response-actions {
  opacity: 1;
}

.chat-user-bubble {
  background: #ffffff;
  border: 1px solid rgba(228, 228, 231, 0.9);
  border-radius: 1.25rem;
  padding-block: 0.375rem;
  padding-inline: 1rem;
  max-width: min(75%, 36rem);
  font-size: 0.875rem;
  line-height: 1.5;
}

.chat-user-bubble .chat-markdown-root {
  font-size: 0.875rem;
}

.chat-user-bubble .chat-markdown-root > :first-child {
  margin-block-start: 0;
}

.chat-user-bubble .chat-markdown-root > :last-child {
  margin-block-end: 0;
}

.tools-used-panel--compact .tools-used-panel-chip {
  padding: 0.25rem 0;
}

.composer-chip-icon img {
  width: 1rem;
  height: 1rem;
  filter: brightness(0) saturate(100%) opacity(0.55);
}

.composer-chip--active .composer-chip-icon img {
  filter: brightness(0) saturate(100%) invert(48%) sepia(74%) saturate(1352%) hue-rotate(167deg)
    brightness(91%) contrast(91%);
}

.chat-thinking-shimmer {
  background: linear-gradient(90deg, #71717a 0%, #d4d4d8 45%, #71717a 90%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: chat-shimmer 1.6s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/chat/components/chat-ui/chat-ui.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,wEAAwE;EACxE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;;;EAGE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE;iCAC+B;AACjC;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,iDAAiD;AACnD","sourcesContent":[".chat-thread-layout {\n  box-sizing: border-box;\n}\n\n.chat-thread-layout-inner:only-child,\n.chat-thread-layout.py-0 .chat-thread-layout-inner {\n  padding-top: 0;\n  padding-bottom: 0.5rem;\n  gap: 0.5rem;\n}\n\n.chat-composer-dock {\n  background: #ffffff;\n}\n\n.chat-composer-shell:focus-within {\n  border-color: rgba(10, 139, 199, 0.45);\n  outline: 2px solid rgba(10, 139, 199, 0.25);\n  outline-offset: 0;\n}\n\n.chat-composer-shell.border-0:focus-within {\n  border-color: transparent;\n  outline: none;\n}\n\n.chat-composer-unified:focus-within {\n  border-color: rgba(10, 139, 199, 0.45);\n  outline: 2px solid rgba(10, 139, 199, 0.25);\n  outline-offset: 0;\n}\n\n.chat-stream-shimmer {\n  height: 0.5rem;\n  width: 8rem;\n  border-radius: 9999px;\n  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 40%, #e5e7eb 80%);\n  background-size: 200% 100%;\n  animation: chat-shimmer 1.4s ease-in-out infinite;\n}\n\n@keyframes chat-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.response-container {\n  margin-bottom: 2rem;\n}\n\n.chat-assistant-row {\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.chat-assistant-avatar,\n.chat-assistant-avatar-spacer {\n  flex: 0 0 auto;\n  width: 1.3125rem;\n  height: 1.3125rem;\n}\n\n.chat-assistant-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0;\n}\n\n.chat-assistant-avatar img {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  display: block;\n}\n\n.chat-assistant-body .chat-markdown-root {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #111827;\n}\n\n.response-container .chat-assistant-body .chat-markdown-root > :first-child,\n.response-container .chat-assistant-body .chat-markdown-root > :first-child > :first-child {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\n.chat-assistant-body .chat-markdown-root pre,\n.chat-assistant-body .chat-markdown-root code {\n  border-color: #e4e4e7;\n}\n\n.chat-assistant-body .chat-markdown-root pre {\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 0.5rem;\n}\n\n.chat-markdown-streamdown {\n  --background: #ffffff;\n  --foreground: #0f172a;\n  --muted: #f4f4f5;\n  --muted-foreground: #64748b;\n  --border: #e8e8ea;\n  --primary: #0a8bc7;\n  --primary-foreground: #ffffff;\n  --radius: 0.625rem;\n}\n\n.chat-markdown-streamdown .chat-markdown-table-scroll,\n.chat-markdown-table-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #c4c4c4 transparent;\n}\n\n.chat-markdown-streamdown table {\n  display: table;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.chat-markdown-mermaid,\n.chat-markdown-streamdown [data-streamdown='mermaid'] {\n  margin: 0.75rem 0;\n  padding: 0.75rem;\n  border: 1px solid #e4e4e7;\n  border-radius: 0.625rem;\n  background: #ffffff;\n  overflow-x: auto;\n}\n\n/* Beat the icon-sized `.prose svg` rule in content-container.css */\n.response-span .prose .chat-markdown-mermaid svg,\n.message-span .prose .chat-markdown-mermaid svg,\n.chat-markdown-mermaid svg {\n  display: block;\n  width: 100% !important;\n  max-width: 100% !important;\n  height: auto !important;\n  max-height: none !important;\n  min-height: 220px;\n  margin: 0 auto;\n  vertical-align: baseline;\n}\n\n.chat-markdown-mermaid .chat-mermaid-canvas {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.chat-assistant-body .chat-markdown-root .typing-cursor {\n  transform: translateY(-0.05em);\n}\n\n.chat-response-actions {\n  opacity: 1;\n}\n\n.chat-user-bubble {\n  background: #ffffff;\n  border: 1px solid rgba(228, 228, 231, 0.9);\n  border-radius: 1.25rem;\n  padding-block: 0.375rem;\n  padding-inline: 1rem;\n  max-width: min(75%, 36rem);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.chat-user-bubble .chat-markdown-root {\n  font-size: 0.875rem;\n}\n\n.chat-user-bubble .chat-markdown-root > :first-child {\n  margin-block-start: 0;\n}\n\n.chat-user-bubble .chat-markdown-root > :last-child {\n  margin-block-end: 0;\n}\n\n.tools-used-panel--compact .tools-used-panel-chip {\n  padding: 0.25rem 0;\n}\n\n.composer-chip-icon img {\n  width: 1rem;\n  height: 1rem;\n  filter: brightness(0) saturate(100%) opacity(0.55);\n}\n\n.composer-chip--active .composer-chip-icon img {\n  filter: brightness(0) saturate(100%) invert(48%) sepia(74%) saturate(1352%) hue-rotate(167deg)\n    brightness(91%) contrast(91%);\n}\n\n.chat-thinking-shimmer {\n  background: linear-gradient(90deg, #71717a 0%, #d4d4d8 45%, #71717a 90%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation: chat-shimmer 1.6s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
